import { useState, useEffect } from "react";
import classNames from "classnames";
import { SearchModelEnum } from "types/qbank/searchModel";
import { MetaDataPropertyTypes } from "types/metaDataPropertyTypes";
import { PropertyCriteria } from "types/qbank/propertyCriteria";
import {
  Button,
  Icon,
  Level,
  LevelLeft,
  LevelRight,
  Loader,
  Title,
} from "components/ui";
import AdvancedSearchInput from "./AdvancedSearchInput";
import { useFilter } from "hooks/filter";
import type { AutoSuggestValue } from "types/autoSuggestValue";
import type { SearchState } from "../../../hooks/search";

export default function AdvancedSearchPanel(props: {
  active: boolean;
  closePanel: () => void;
  propertyTypes: MetaDataPropertyTypes;
}) {

  const transformToStateFormat = (dataArray: AutoSuggestValue[]) => {
    const transformedData: any = {};
    const propertyCriteria: PropertyCriteria[] = [];
    dataArray.forEach((item: AutoSuggestValue) => {
      if (item.propertyCriteria !== undefined) {
        const { systemName, value } = item.propertyCriteria;
        //HierarchicalTree use ">>" to join the values
        let formattedValues = value;
        if (Array.isArray(value)) {
          formattedValues = value.map((subItem: any) =>
          Array.isArray(subItem) ? subItem.join('>>') : subItem
        );
        }
        transformedData[systemName] = formattedValues;
        propertyCriteria.push(item.propertyCriteria);
      }
    });
    //set the advanced search filters
    setAdvancedSearchFilters(propertyCriteria);
    return transformedData;
  };

  const hasValidActiveFilters = (searchState: SearchState) => {
    return (
      searchState &&
      Array.isArray(searchState.activeFilters) &&
      searchState.activeFilters.length > 0
    );
  };

  useEffect(() => {
    if (hasValidActiveFilters(searchState)) {
      setInputValues(transformToStateFormat(searchState.activeFilters));

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { searchState, searchDispatch } = useFilter();
  let [advancedSearchFilters, setAdvancedSearchFilters] = useState<
    PropertyCriteria[]
  >([]);
  let [inputValues, setInputValues] = useState<{ [key: string]: any }>({});

  function setCriteria(propertyCriteria: PropertyCriteria) {
    setAdvancedSearchFilters((prevFilters) => {
      let clone = prevFilters.filter(
        (existingCriteria) =>
          existingCriteria.systemName !== propertyCriteria.systemName
      );

      if (propertyCriteria.value !== undefined) {
        clone.push(propertyCriteria);
      }

      return clone;
    });
  }


  function search() {
    setAdvancedSearchFilters([]);
    setInputValues({});
    searchDispatch({
      type: "ADD_FILTER",
      payload: {
        criteria: SearchModelEnum.properties,
        value: "",
        overwrite: true,
        propertyCriteria: advancedSearchFilters,
        label: true,
      },
    });

    props.closePanel();
  }

  const classes = classNames("advanced-search-panel scroll-bars", {
    "is-active": props.active,
  });

  return (
    <>
      <div className="advanced-search-main">
    <div className={classes}>
      <Level>
        <LevelLeft
          className="advanced-search-panel-back is-clickable"
          onClick={props.closePanel}
        >
          <Icon name="arrow-left" />
          <Title size={5}>Back</Title>
        </LevelLeft>

        <LevelRight>
          <Button
                onClick={() => setInputValues({})}
          >
            Clear all filters
          </Button>
        </LevelRight>
      </Level>

      {props.propertyTypes ? (
        searchState.currentCategory.propertyRequests.map((systemName) => (
          <div key={systemName}>
            <AdvancedSearchInput
              systemName={systemName}
              propertyTypes={props.propertyTypes}
              setCriteria={setCriteria}
              value={inputValues[systemName]}
              setInputValues={setInputValues}
            />
          </div>
        ))
      ) : (
        <Loader />
      )}
        </div>
        <div className="advanced-search-search-button">
      <Button
        color="primary"

        onClick={search}
      >
        Search
      </Button>
        </div>
      </div>
    </>
  );
}
